import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, of as observableOf} from 'rxjs';
import {takeWhile} from 'rxjs/operators';

import {NbLayoutDirection, NbLayoutDirectionService} from '@nebular/theme';

export type ThemeLayoutState = {
  name: string,
  icon: string,
  id: string,
  selected?: boolean,
};

@Injectable({providedIn: 'root'})
export class StateService implements OnDestroy {

  protected layouts: ThemeLayoutState[] = [
    {
      name: 'One Column',
      icon: 'layout-outline', // 'nb-layout-default'
      id: 'one-column',
      selected: true,
    },
    {
      name: 'Two Column',
      icon: 'layout-outline', // 'nb-layout-two-column'
      id: 'two-column',
    },
    {
      name: 'Center Column',
      icon: 'layout-outline', // 'nb-layout-centre'
      id: 'center-column',
    },
  ];

  protected sidebars: ThemeLayoutState[] = [
    {
      name: 'Sidebar at layout start',
      icon: 'layout-outline', // 'nb-layout-sidebar-left'
      id: 'start',
      selected: true,
    },
    {
      name: 'Sidebar at layout end',
      icon: 'layout-outline', // 'nb-layout-sidebar-right'
      id: 'end',
    },
  ];

  protected layoutState$ = new BehaviorSubject(this.layouts[0]);
  protected sidebarState$ = new BehaviorSubject(this.sidebars[0]);

  alive = true;

  constructor(directionService: NbLayoutDirectionService) {
    directionService.onDirectionChange()
      .pipe(takeWhile(() => this.alive))
      .subscribe(direction => this.updateSidebarIcons(direction));

    this.updateSidebarIcons(directionService.getDirection());
  }

  ngOnDestroy() {
    this.alive = false;
  }

  private updateSidebarIcons(direction: NbLayoutDirection) {
    const [ startSidebar, endSidebar ] = this.sidebars;
    const startIconClass = 'layout-outline';
    const endIconClass = 'layout-outline';
    startSidebar.icon = startIconClass;
    endSidebar.icon = endIconClass;
  }

  setLayoutState(state: ThemeLayoutState): void {
    this.layoutState$.next(state);
  }

  getLayoutStates(): Observable<ThemeLayoutState[]> {
    return observableOf(this.layouts);
  }

  onLayoutState(): Observable<ThemeLayoutState> {
    return this.layoutState$.asObservable();
  }

  setSidebarState(state: ThemeLayoutState): void {
    this.sidebarState$.next(state);
  }

  getSidebarStates(): Observable<ThemeLayoutState[]> {
    return observableOf(this.sidebars);
  }

  onSidebarState(): Observable<ThemeLayoutState> {
    return this.sidebarState$.asObservable();
  }
}
